import constants from "../../../../shared/constants";

function G2W() {
  window.location = constants.g2wURL;
  return null;
}

export default G2W;
